import React from 'react';
import { Link } from 'react-router-dom';

import { ListItem, ListItemIcon, ListItemText } from '@mui/material';

import ProductionQuantityLimitsIcon from '@mui/icons-material/ProductionQuantityLimits';
import { MenuItem } from 'types/global';

type Props = {
	selected: MenuItem;
	onSelect(event?: React.MouseEvent<HTMLDivElement, MouseEvent>, index?: MenuItem): void;
	open?: boolean;
};

export default function SoldProducts({ selected, onSelect, open }: Props) {
	return (
		<ListItem
			button
			component={Link}
			to="/sold-products"
			selected={selected === MenuItem.SoldProducts}
			onClick={(event: React.MouseEvent<HTMLDivElement, MouseEvent> | any) => onSelect(event, MenuItem.SoldProducts)}
		>
			<ListItemIcon>
				<ProductionQuantityLimitsIcon />
			</ListItemIcon>
			{open && <ListItemText primary={'Venta de Productos'} />}
		</ListItem>
	);
}
